<template>
  <div>
    <b-form-select
      v-model="scopeFilter"
      :options="scopeOptions"
      class="mb-3 admin-elements-scope-filter"
    />
    <b-table
      :items="filteredRows"
      :fields="fields"
      hover
      responsive
      show-empty
      :empty-text="$t('webmag.emptyFilteredText')"
    >
      <template #cell(preview)="{ item }">
        <img
          v-if="item.data && item.data.preview"
          :src="thumbUrl(item.data.preview)"
          class="admin-element-thumb"
          alt=""
        />
      </template>
      <template #cell(title)="{ item }">
        <div>{{ item.data && item.data.title_de }}</div>
        <div class="text-muted small">{{ item.data && item.data.title_en }}</div>
      </template>
      <template #cell(scope)="{ item }">
        {{ item.group_id === null ? 'Global' : (groupNameMap[item.group_id] || `Group ${item.group_id}`) }}
      </template>
      <template #cell(status)="{ item }">
        <b-badge :variant="item.data && item.data.active === false ? 'warning' : 'success'">
          {{ item.data && item.data.active === false ? 'Draft' : 'Active' }}
        </b-badge>
      </template>
      <template #cell(categories)="{ item }">
        {{ (item.data && item.data.categories || []).join(', ') }}
      </template>
      <template #cell(tags)="{ item }">
        <span v-if="item.data && item.data.element_tags">
          {{ [
            ...(item.data.element_tags.de || []),
            ...(item.data.element_tags.en || []),
          ].join(', ') }}
        </span>
      </template>
      <template #cell(actions)="{ item }">
        <b-button size="sm" variant="outline-primary" @click="$emit('edit-element', item)">
          <b-icon icon="pencil" />
        </b-button>
        <b-button
          size="sm"
          variant="outline-secondary"
          class="ml-2"
          title="Duplicate"
          @click="$emit('duplicate-element', item)"
        >
          <b-icon icon="files" />
        </b-button>
        <b-button size="sm" variant="outline-danger" class="ml-2" @click="$emit('delete-element', item)">
          <b-icon icon="trash" />
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'AdminElementsTable',
  props: {
    elements: {
      type: Array,
      required: true,
    },
    groups: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      scopeFilter: 'all',
      fields: [
        { key: 'preview', label: '' },
        { key: 'name', label: 'Name', sortable: true },
        { key: 'description', label: 'Description' },
        { key: 'title', label: 'Title (de/en)' },
        { key: 'scope', label: 'Scope' },
        { key: 'status', label: 'Status' },
        { key: 'categories', label: 'Categories' },
        { key: 'tags', label: 'Tags' },
        { key: 'actions', label: '' },
      ],
    };
  },
  computed: {
    groupNameMap() {
      const map = {};
      this.groups.forEach((g) => {
        map[g.group_id] = g.name;
      });
      return map;
    },
    scopeOptions() {
      const groupsInUse = new Map();
      this.elements.forEach((e) => {
        if (e.group_id !== null) {
          groupsInUse.set(e.group_id, this.groupNameMap[e.group_id] || `Group ${e.group_id}`);
        }
      });
      return [
        { value: 'all', text: 'All' },
        { value: 'global', text: 'Global' },
        ...Array.from(groupsInUse.entries()).map(([value, text]) => ({ value, text })),
      ];
    },
    filteredRows() {
      if (this.scopeFilter === 'all') return this.elements;
      if (this.scopeFilter === 'global') return this.elements.filter((e) => e.group_id === null);
      return this.elements.filter((e) => e.group_id === this.scopeFilter);
    },
  },
  methods: {
    thumbUrl(preview) {
      const bunnyUrl = this.$transformS3ToBunnyUrl(preview);
      if (bunnyUrl !== preview) {
        const sep = bunnyUrl.includes('?') ? '&' : '?';
        return `${bunnyUrl}${sep}width=160&quality=85`;
      }
      return preview;
    },
  },
};
</script>

<style scoped>
.admin-element-thumb {
  max-width: 80px;
  max-height: 48px;
  object-fit: cover;
  border-radius: 4px;
}
.admin-elements-scope-filter {
  max-width: 300px;
}
</style>
